import PubSub from "pubsub-js";
import { sumItemQuantity } from "vino/utils";

export default PubSub;

export const CART_TOPICS = {
	CART_ITEM_CHANGED: "vino_cart_item_changed",
	CART_ITEM_REMOVED: "vino_cart_item_removed",
	CLEAR_CART: "vino_clear_cart",
};

export const dispatchCartItemsChanged = (lineItems) => {
	const total = sumItemQuantity(lineItems);
	PubSub.publish(CART_TOPICS.CART_ITEM_CHANGED, {
		totalItems: total,
	});
};

export const subscribeCartItemsChanged = (callback) => {
	if (window.vinoPubSub) {
		window.vinoPubSub.subscribe(CART_TOPICS.CART_ITEM_CHANGED, callback);
	}
};

export const unsubscribeCartItemsChanged = () => {
	if (window.vinoPubSub) {
		window.vinoPubSub.unsubscribe(CART_TOPICS.CART_ITEM_CHANGED);
	}
};

export const dispatchCartItemRemoved = (lineItemId) => {
	PubSub.publish(CART_TOPICS.CART_ITEM_REMOVED, {
		lineItemId,
	});
};

export const subscribeCartItemRemoved = (callback) => {
	if (window.vinoPubSub) {
		window.vinoPubSub.subscribe(CART_TOPICS.CART_ITEM_REMOVED, callback);
	}
};

export const unsubscribeCartItemRemoved = () => {
	if (window.vinoPubSub) {
		window.vinoPubSub.unsubscribe(CART_TOPICS.CART_ITEM_REMOVED);
	}
};

export const dispatchClearCart = () => {
	PubSub.publish(CART_TOPICS.CLEAR_CART);
};

export const subscribeClearCart = (callback) => {
	if (window.vinoPubSub) {
		window.vinoPubSub.subscribe(CART_TOPICS.CLEAR_CART, callback);
	}
};

export const unsubscribeClearCart = () => {
	if (window.vinoPubSub) {
		window.vinoPubSub.unsubscribe(CART_TOPICS.CLEAR_CART);
	}
};
